import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function RegisterNote() {
  const { user } = useUser()
  let view = contentLayout[modules.CreateNote]
  // Creating notes is a write permission on storage/sales movements
  const hasPermission = user.permissions.views.join().includes(modules.RegisterSale.toLowerCase())
  
  if (user.permissions.views.length && !hasPermission) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.CreateNote}></Index>
  )
}

export default RegisterNote
